import { render, staticRenderFns } from "./DialogTree.vue?vue&type=template&id=0f63d160&scoped=true&"
import script from "./DialogTree.vue?vue&type=script&lang=js&"
export * from "./DialogTree.vue?vue&type=script&lang=js&"
import style0 from "./DialogTree.vue?vue&type=style&index=0&id=0f63d160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63d160",
  null
  
)

export default component.exports